module.exports = __webpack_public_path__ + "img/substance-use.097edc4.svg";